import { getFileUploadUrl } from "../utils/get-file-upload-url.js";
import { uploadFile } from "../utils/upload-file.js";
// src/modules/Files/shared/handle-upload-file.ts
async function handleUploadFile(file) {
	const fileInfo = {
		file,
		id: Math.random().toString(),
		name: file.name,
		size: file.size,
		status: "processing",
		type: file.type
	};
	const { accessUrl, uploadMethod, uploadUrl } = await getFileUploadUrl(fileInfo);
	fileInfo.uploadUrl = uploadUrl;
	fileInfo.uploadMethod = uploadMethod;
	const { uploadPromise } = uploadFile(fileInfo);
	await uploadPromise;
	return accessUrl;
}
export { handleUploadFile };

//# sourceMappingURL=handle-upload-file.js.map